import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { LoadingScreen } from 'components';
import styles from './redirectpayments.module.scss';
import { Grid, Button, Dialog, DialogActions, DialogTitle, Typography, Select, MenuItem } from '@material-ui/core';
const ModalRedirectPayments = (props) => {
    const {
        setShowCsDownModal,
        setTrafficValue,
        trafficValue,
        showCsDownModal,
        loading,
        disable,
        handleClose,
        submitHandler
    } = props;
    return (
        <Dialog
            open={showCsDownModal}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className={styles.modalContainer}
        >
            <LoadingScreen open={loading} />
            <DialogTitle id="draggable-dialog-title" stickyHeader className={styles.dialogHeader}>
                Are you sure you want to redirect payments to the fallback gateway ?
            </DialogTitle>
            <Typography className={styles.paymentTitle}>
                If you modify this payments will be redirect to the fallback gateway
            </Typography>
            <Grid
                container
                xs={10}
                md={10}
                sm={10}
                direction="row"
                justify="space-between"
                alignItems="center"
                spacing={2}
                className={styles.containerStyles}
            >
                <Grid item xs={6} sm={6} md={6}>
                    <Typography className={styles.trafficTextStyle}> % Traffic to switch ?</Typography>
                </Grid>
                <Grid item xs={5} sm={5} md={5} direction="row" spacing={1}>
                    <Select
                        className={styles.selectDropDownbtn}
                        variant="outlined"
                        onChange={(e) => {
                            setTrafficValue(e.target.value);
                        }}
                        label="SELECT %"
                        value={trafficValue}
                    >
                        <MenuItem value={'0'}>0%</MenuItem>
                        <MenuItem value={'25'}>25%</MenuItem>
                        <MenuItem value={'50'}>50%</MenuItem>
                        <MenuItem value={'75'}>75%</MenuItem>
                        <MenuItem value={'100'}>100%</MenuItem>
                    </Select>
                </Grid>
            </Grid>
            <DialogActions>
                <Button variant="outlined" onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button
                    className={styles.yesBtn}
                    variant="contained"
                    onClick={submitHandler}
                    color="primary"
                    disabled={!trafficValue}
                >
                    Yes
                </Button>
            </DialogActions>
        </Dialog>
    );
};
ModalRedirectPayments.propTypes = {};
export default ModalRedirectPayments;
